import {Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import * as _ from 'lodash';
import { BsModalRef } from "ngx-bootstrap/modal";
import { RequestService } from "../../../../services/request/request.service";
import { AlertBannerService, AlertType } from "../../../../lib/alert-banner";
import { ConstantsService } from "../../../../services/constants/constants.service";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import {NgModel} from "@angular/forms";
import {environment} from "../../../../../environments/environment";
import * as Cookies from "js-cookie";

@Component({
  selector: 'app-add-background-check-modal',
  templateUrl: './add-background-check-modal.component.pug',
  styleUrls: ['./add-background-check-modal.component.scss'],
  standalone: false
})
export class AddBackgroundCheckModalComponent implements OnInit, OnDestroy {
  selectedItems: any = [];
  dropdownPlaceholder = $localize`Select one or more background checks`;
  isEdit = false;
  acicBackgroundCheck = ConstantsService.ACIC_SHORT_NAME;
  ukdbsBackgroundCheck = ConstantsService.UKDBSC_SHORT_NAME;
  icrcBackgroundCheck = ConstantsService.ICRC_SHORT_NAME;
  nccpcBackgroundCheck = ConstantsService.NCC_PC_SHORT_NAME;
  nccmojBackgroundCheck = ConstantsService.NCC_MOJ_SHORT_NAME;
  nccbankruptcyBackgroundCheck = ConstantsService.NCC_BANKRUPTCY_SHORT_NAME;
  amlBackgroundCheck = ConstantsService.AML_SHORT_NAME;
  bannedBackgroundCheck = ConstantsService.BANNED_SHORT_NAME;
  @ViewChild('middleNameRef') middleNameField!: NgModel;
  birthYearPlaceholder = ConstantsService.BIRTH_YEAR_PLACEHOLDER
  yearOptions: { key: string; value: string }[] = [];
  fuzzinessToolTip = ConstantsService.FUZZINESS_TOOLTIP
  fuzzinessOptions: { key: string; value: string }[] = ConstantsService.FUZZINESSOPTIONS;
  fuzziness = 'Exact match'
  countryPlaceholder = ConstantsService.AML_COUNTRY_PLACEHOLDER
  countryItems:any = []
  selectedCodes: any = [];
  receipientId = -1
  items: any = []
  headingText = ''
  role = ''
  hiringOrganisation = ''
  employmentSector = ''
  country = ''
  directorshipCountries = ConstantsService.DIRECTORSHIP_COUNTRIES
  directorshipCountryPlaceholder = ConstantsService.DIRECTORSHIP_COUNTRY_PLACEHOLDER
  employmentType = ''
  employmentValue = ''
  employmentCoverage = '5'
  verificationEmpMin = '2'
  verificationEmpMax = '3'
  verificationQualMin = '1'
  verificationQualMax = '3'
  verificationCredMin = '1'
  verificationCredMax = '3'
  employmentQuantityMin = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  employmentQuantityMax = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  educationQuantityMin = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  educationQuantityMax = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  credentialQuantityMin = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  credentialQuantityMax = _.cloneDeep(ConstantsService.EMPLOYMENT_QUANTITY);
  educationScopeOptions = _.cloneDeep(ConstantsService.CENTRIC_EDUCATION_SCOPE);
  selectEducationScope = $localize`Highest education`;
  verificationType = 'highest';
  trust1101Centric = false;
  trust1225Wwcc = false;
  trust1337DirectorshipCreditChecks = false;
  wwccWarningMessage = ConstantsService.WWCC_NSW_ACT_WARNING;
  wwccWarningIcon = 'https://assets.xref.com/omni/shared/error_amber.svg';
  onSave: EventEmitter<any> = new EventEmitter();

  errors = [
    {'name': 'validName', 'msg': $localize`Check name is a required field.`, 'enabled': false},
    {'name': 'sameName', 'msg': $localize`Check name must be unique.`, 'enabled': false},
  ];
  draftReferenceUid: string | null = '';
  checks: any = {}
  disableSend = true;
  additionalFields: any[] = [];
  editModalSubheader = $localize`Edit the additional background checks for this recipient.`;
  addModalSubheader = $localize`Select any background checks you want to add for this recipient.`;
  saveButtonText = $localize`Add`;
  mainHeader = '';
  private styleElement: HTMLStyleElement;
  employmentSectorSelected:undefined|number = undefined;
  dropDownFocusOutCalled:undefined|number = undefined;
  dropDownClickedCalled:undefined|number = undefined;
  dropDownClickedcount:number = 0;
  multiSelectOpenedcount:number = 0;
  multiSelectOpened:undefined|boolean = undefined;
  multiSelectHidden:undefined|boolean = undefined;
  selectType = $localize`Select type`;
  canManageBCG = false;
  searchTitle = $localize`Background checks will appear here`;
  searchDescription = $localize`Background checks made available through Trust Marketplace will appear here.`;
  searchDescriptionNoPermission = $localize`Background checks made available through Trust Marketplace will appear here. Contact your background check administrator to complete setup within Trust Marketplace.`;
  createBtn = $localize`Go to Trust Marketplace`
  middleName = ''
  birth_year = ''
  employmentcoverages = _.cloneDeep(ConstantsService.EMPLOYMENT_COVERAGE);
  trustUrl: string = environment.TRUST_MARKETPLACE_URL;
  languageLocal = Cookies.get(ConstantsService.XREF_LOCALE)?.toUpperCase();

  constructor(public _bsModalRef: BsModalRef, public requestService: RequestService, public alertList: AlertBannerService, public permissionService: PermissionsService, public eRef: ElementRef) {
    this.trust1101Centric = this.permissionService.isFeatureActivated('trust-1101-centric');
    this.trust1225Wwcc = this.permissionService.isFeatureActivated('trust-1225-certn-wwcc');
    this.trust1337DirectorshipCreditChecks = this.permissionService.isFeatureActivated('trust-1337-directorship-credit-checks');
    if (this.trust1101Centric) {
      this.employmentcoverages = _.cloneDeep(ConstantsService.CENTRIC_EMPLOYMENT_COVERAGE);
      this.employmentQuantityMin = _.cloneDeep(ConstantsService.CENTRIC_EMPLOYERS_QUANTITY_MIN);
      this.employmentQuantityMax = _.cloneDeep(ConstantsService.CENTRIC_EMPLOYERS_QUANTITY_MAX);
      this.credentialQuantityMin = _.cloneDeep(ConstantsService.CENTRIC_CREDENTIALS_QUANTITY_MIN);
      this.credentialQuantityMax = _.cloneDeep(ConstantsService.CENTRIC_CREDENTIALS_QUANTITY_MAX);
    }
    this.canManageBCG = this.permissionService.hasPermission("can_use_link_to_trust")
    if (localStorage.getItem('draft_reference_uid')) {
      this.draftReferenceUid = localStorage.getItem('draft_reference_uid');
    }
    this.styleElement = document.createElement('style');
  }

  ngOnInit(): void {
    this.mainHeader = (this.isEdit) ? $localize`Edit background checks`: $localize`Add background checks`;
    if(this.isEdit){
      this.saveButtonText = $localize`Save`;
    }
    if(this.selectedItems.length == 0){
      this.reset();
    }
    if(this.employmentValue){
      const employmentType = ConstantsService.EMPLOYMENT_TYPE.find(type => type.value === this.employmentValue);
      this.employmentType = employmentType ? employmentType.key : ConstantsService.EMPLOYMENT_TYPE[0].key;
    }
    else {
        this.employmentType = ConstantsService.EMPLOYMENT_TYPE[0].key
        this.employmentValue = ConstantsService.EMPLOYMENT_TYPE[0].value
    }

    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= 1870; year--) {
        this.yearOptions.push({
          key: year.toString(),
          value: year.toString(),
        });
    }
    if(this.selectedCodes.length > 0) {
        this.countryItems = this.countryItems.map(country => ({
          ...country,
          checked: this.selectedCodes.some(sel => sel.value === country.value)
        }));
    }

    this.setItems();
    this.updateAdditionalFields();
    this.applyStylesToFlowDropdown();
  }

  applyStylesToFlowDropdown() {
    if (this.containsMobileId(this.items)) {
      this.adjustDropdownStylesForMobileId();
    } else {
      this.removeFlowDropdownStyles();
    }
  }

  adjustDropdownStylesForMobileId() {
    const mobileIdObject = this.items.find(item => item.short_name === "mobile_id");
    const numberOfFlows = mobileIdObject && mobileIdObject.flow ? mobileIdObject.flow.length : 0;

    if (numberOfFlows < 3) {
      return;
    } else if (numberOfFlows == 3) {
      this.updateDropdownPosition(-80, 0)
    } else if (numberOfFlows > 3) {
      this.updateDropdownPosition(-130, 0)
    }
  }

  ngOnDestroy() {
    // Remove the style element when the component is destroyed
    this.removeFlowDropdownStyles();
  }

  removeFlowDropdownStyles(){
    if (this.styleElement && this.styleElement.parentNode) {
      this.styleElement.parentNode.removeChild(this.styleElement);
    }
  }

  setItems() {
    const isMobileIdSelected = this.selectedItems.some(
      (selectedItem: any) => selectedItem.short_name === 'mobile_id'
    );

    this.items.forEach((item: any) => {
      item.checked = this.selectedItems.some((selectedItem: any) => {
        return selectedItem.short_name === item.short_name;
      });

      if (item.short_name == 'mobile_id' && !isMobileIdSelected){
        item.flow.forEach((flowItem: any) => {
          flowItem.checked = false;
        });
      }
    });
  }

  selectedItemsEmitter($event) {
    this.selectedItems = $event;
    this.updateAdditionalFields()

  }

  get showWwccWarning(): boolean {
    return this.trust1225Wwcc && this.selectedItems?.some(
      (item: any) => item.short_name === ConstantsService.WWCC_SHORT_NAME
    );
  }

  updateAdditionalFields(){
    this.additionalFields = []
    for (let selectedItem of this.selectedItems) {
      if (selectedItem.short_name === ConstantsService.UKDBSC_SHORT_NAME || (this.trust1101Centric && selectedItem.short_name === ConstantsService.ICRC_SHORT_NAME)) {
        if (!this.additionalFields.includes('employment_sector')) {
          this.additionalFields.push('employment_sector')
        }
      }
      if (selectedItem.short_name === ConstantsService.ACIC_SHORT_NAME) {
        if (!this.additionalFields.includes('hiring_organisation') && !this.additionalFields.includes('place_work')) {
          this.additionalFields.push('hiring_organisation')
        }
      }
      if (selectedItem.short_name == ConstantsService.ACIC_SHORT_NAME || selectedItem.short_name == ConstantsService.UKDBSC_SHORT_NAME || selectedItem.short_name === ConstantsService.NCC_PC_SHORT_NAME || selectedItem.short_name === ConstantsService.NCC_MOJ_SHORT_NAME || selectedItem.short_name === ConstantsService.NCC_BANKRUPTCY_SHORT_NAME || (this.trust1101Centric && selectedItem.short_name === ConstantsService.ICRC_SHORT_NAME)) {
          if (!this.additionalFields.includes('role')) {
            this.additionalFields.push('role')
          }
        }
      if (selectedItem.short_name === ConstantsService.NCC_PC_SHORT_NAME || (selectedItem.short_name === ConstantsService.NCC_MOJ_SHORT_NAME) || selectedItem.short_name === ConstantsService.NCC_BANKRUPTCY_SHORT_NAME ){
          if (!this.additionalFields.includes('type')) {
            this.additionalFields.push('type')
          }
          if (!this.additionalFields.includes('place_work') && !this.additionalFields.includes('hiring_organisation')) {
            this.additionalFields.push('place_work')
          }
          else if (!this.additionalFields.includes('place_work') && this.additionalFields.includes('hiring_organisation'))
          {
            const index = this.additionalFields.indexOf('hiring_organisation');
            this.additionalFields[index] = 'place_work';
          }
        }
      if (selectedItem.short_name === this.amlBackgroundCheck || selectedItem.short_name === this.bannedBackgroundCheck ) {
          if (!this.additionalFields.includes('middle_name')) {
            this.additionalFields.push('middle_name')
          }
        }
      if (selectedItem.short_name === this.amlBackgroundCheck) {
          if (!this.additionalFields.includes('birth_year')) {
            this.additionalFields.push('birth_year')
          }
          if (!this.additionalFields.includes('country_codes')) {
            this.additionalFields.push('country_codes')
          }
          if (!this.additionalFields.includes('fuzziness')) {
            this.additionalFields.push('fuzziness')
          }

        }

      // Centric Credential/Education have no flow selection — drive fields from the parent check.
      if (this.trust1101Centric && selectedItem.short_name === ConstantsService.EDUV_SHORT_NAME) {
          if (!this.additionalFields.includes('verification_type')) this.additionalFields.push('verification_type');
      }
      if (this.trust1101Centric && selectedItem.short_name === ConstantsService.CV_SHORT_NAME) {
          if (!this.additionalFields.includes('verification_cred_min')) this.additionalFields.push('verification_cred_min');
      }

      if (this.trust1337DirectorshipCreditChecks && selectedItem.short_name === ConstantsService.DIRECTORSHIP_CHECK_SHORT_NAME) {
          if (!this.additionalFields.includes('country')) {
            this.additionalFields.push('country')
          }
      }

      if(selectedItem.flow && selectedItem.short_name !== "mobile_id"){
          for (let flow of selectedItem.flow){
              if(flow.checked && flow.short_name === ConstantsService.EMPV_SQ_SHORT_NAME ){
                  if (!this.additionalFields.includes('verification_emp_min')) this.additionalFields.push('verification_emp_min');
              }
              if(flow.checked && flow.short_name === ConstantsService.EMPV_CP_SHORT_NAME ){
                  if (!this.additionalFields.includes('verification_years')) this.additionalFields.push('verification_years');
              }
              if(flow.checked && flow.short_name === ConstantsService.EDUV_SQ_SHORT_NAME ){
                  if (this.trust1101Centric) {
                      if (!this.additionalFields.includes('verification_type')) this.additionalFields.push('verification_type');
                  } else if (!this.additionalFields.includes('verification_qual_min')) {
                      this.additionalFields.push('verification_qual_min');
                  }
              }
              if(this.trust1101Centric && flow.checked && flow.short_name === ConstantsService.EDUV_HL_SHORT_NAME ){
                  if (!this.additionalFields.includes('verification_type')) this.additionalFields.push('verification_type');
              }
              if(flow.checked && flow.short_name === ConstantsService.CV_SQ_SHORT_NAME ){
                  if (!this.additionalFields.includes('verification_cred_min')) this.additionalFields.push('verification_cred_min');
              }
          }
      }
    }
    this.additionalFields.sort()
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if(this.eRef.nativeElement.contains(event.target)) {
    } else {
      if ((this.employmentSectorSelected != undefined && this.dropDownFocusOutCalled != 1 && this.multiSelectOpened != undefined && this.multiSelectOpenedcount % 2 === 0) ||
      (this.employmentSectorSelected != undefined && this.dropDownFocusOutCalled == 1 && this.dropDownClickedCalled == 0 && this.dropDownClickedcount % 2 === 0 && this.multiSelectOpened != undefined && this.multiSelectOpenedcount % 2 === 0) ||
        (this.multiSelectHidden)){

        this._bsModalRef.hide()
      }
    }
    this.dropDownClickedCalled = 0;
    this.dropDownFocusOutCalled = 0;
    this.employmentSectorSelected = 0;
    this.multiSelectOpened = false;
    this.multiSelectHidden = false;
  }

  dropDownOptionSelected($event: any) {
    this.employmentSector = $event.value
    if(this.dropDownFocusOutCalled){
      this.employmentSectorSelected = 1;
    }
  }

  employmentTypeOptionSelected($event: any) {
    this.employmentType = $event.key
    this.employmentValue = $event.value
  }

  employmentCoverageSelected($event: any) {
    this.employmentCoverage = $event.value
  }

  employmentQualSelected($event: any, type) {
      if(type==='min'){
          this.verificationEmpMin = $event.value
      }
      else if(type=='max'){
        this.verificationEmpMax = $event.value;
      }

  }

  eduQualSelected($event: any, type) {
      if(type==='min'){
          this.verificationQualMin = $event.value
      }
      else if(type=='max'){
        this.verificationQualMax = $event.value;
      }

  }

  educationScopeSelected($event: any) {
      this.verificationType = $event.key;
      this.selectEducationScope = $event.value;
  }

  credQualSelected($event: any, type) {
      if(type==='min'){
          this.verificationCredMin = $event.value
      }
      else if(type=='max'){
        this.verificationCredMax = $event.value;
      }

  }

  dropDownClicked($event: any) {
    this.removeFlowDropdownStyles();
    if(this.employmentSectorSelected){
      this.dropDownClickedCalled = 0;
    }
    else{
      this.dropDownClickedCalled = this.dropDownClickedCalled === 0 ? 1 : 0;
    }
    this.dropDownClickedcount = this.dropDownClickedcount + 1;
  }

  directorshipCountrySelected($event) {
    this.country = $event.value;
  }

  dropDownFocusOut($event: any) {
    setTimeout(() => {
      this.styleElement = document.createElement('style');
     this.updateDropdownPosition(-130, 0)
    }, 200);
    this.dropDownFocusOutCalled = this.dropDownFocusOutCalled === 0 ? 1 : 0;
  }

  save() {
    if (localStorage.getItem('draft_reference_uid')) {
      this.draftReferenceUid = localStorage.getItem('draft_reference_uid');

      this.checks = this.prepareChecksForPayload();
      if(!this.checks?.checks?.[this.acicBackgroundCheck] && !this.checks?.checks?.[this.nccpcBackgroundCheck] && !this.checks?.checks?.[this.nccmojBackgroundCheck] && !this.checks?.checks?.[this.nccbankruptcyBackgroundCheck] ){
          this.hiringOrganisation = '';
        }
      if(!(this.checks?.checks?.[this.acicBackgroundCheck] || this.checks?.checks?.[this.ukdbsBackgroundCheck] || this.checks?.checks?.[this.nccpcBackgroundCheck] || this.checks?.checks?.[this.nccmojBackgroundCheck] || this.checks?.checks?.[this.nccbankruptcyBackgroundCheck] || (this.trust1101Centric && this.checks?.checks?.[this.icrcBackgroundCheck]))){
          this.role = '';
        }
      if(!this.checks?.checks?.[this.ukdbsBackgroundCheck] && !(this.trust1101Centric && this.checks?.checks?.[this.icrcBackgroundCheck])){
        this.employmentSector = '';
      }

      if(!this.checks?.checks?.[this.amlBackgroundCheck] && !this.checks?.checks?.[this.bannedBackgroundCheck]){
          this.middleName = '';
      }
      if(!this.checks?.checks?.[this.amlBackgroundCheck]){
          this.birth_year = '';
          this.selectedCodes = [];
          this.fuzziness = 'Exact match';
      }
      if(!this.checks?.checks?.[ConstantsService.CV_SHORT_NAME]){
          this.verificationCredMin = '1';
          this.verificationCredMax = '3';
      }
      if(!this.checks?.checks?.[ConstantsService.EDUV_SHORT_NAME]){
          this.verificationQualMin = '1';
          this.verificationQualMax = '3';
      }
      if(!this.checks?.checks?.[ConstantsService.EMPV_SHORT_NAME]){
          this.verificationEmpMin = '2';
          this.verificationEmpMax = '3';
          this.employmentCoverage = '5';
      }
      else{
          if(!this.checks?.checks?.[ConstantsService.EMPV_SHORT_NAME]?.['verification_years']){
              this.employmentCoverage = '5';
          }
          else {
              this.verificationEmpMin = '2';
              this.verificationEmpMax = '3';
          }
      }
      this.requestService.setBackgroundChecks(this.draftReferenceUid, this.checks, this.receipientId).subscribe((data: any) => {
        this._bsModalRef.hide()
        const result = {
        data: data?.data,
        role: this.role,
        hiring_organisation: this.hiringOrganisation,
        employment_sector: this.employmentSector,
        employment_type: this.employmentType,
        reason: this.role,
        middle_name: this.middleName,
        fuzziness: this.fuzziness,
        country_codes: this.selectedCodes,
        country: this.country,
        birth_year: this.birth_year,
        employmentCoverage: this.employmentCoverage,
        verificationEmpMin: this.verificationEmpMin,
        verificationEmpMax: this.verificationEmpMax,
        verificationQualMin: this.verificationQualMin,
        verificationQualMax: this.verificationQualMax,
        verificationCredMin: this.verificationCredMin,
        verificationCredMax: this.verificationCredMax,
        items: this.items
        }
        this.onSave.emit(result);
    },
      (err: any) => {
          console.log(err);
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        })
    }
  }

  prepareChecksForPayload() {
    this.checks = {checks: {}};
    for (const check of this.selectedItems) {
      let checkKey = check.short_name;
      const checkData = {};
      if (check.short_name === ConstantsService.ACIC_SHORT_NAME) {
        checkData['role'] = this.role
        checkData['hiring_organisation'] = this.hiringOrganisation
      }

      if (check.short_name === ConstantsService.UKDBSC_SHORT_NAME) {
        checkData['employment_sector'] = this.employmentSector
        checkData['role'] = this.role
      }
    
      if (this.trust1101Centric && check.short_name === ConstantsService.ICRC_SHORT_NAME) {
        checkData['employment_sector'] = this.employmentSector
        checkData['role'] = this.role
      }
      
      if (check.short_name === ConstantsService.NCC_PC_SHORT_NAME || check.short_name === ConstantsService.NCC_MOJ_SHORT_NAME || check.short_name === ConstantsService.NCC_BANKRUPTCY_SHORT_NAME ) {
          checkData['type'] = this.employmentType
          checkData['reason'] = this.role
          checkData['place_work'] = this.hiringOrganisation
      }

      if (check.short_name === this.amlBackgroundCheck || check.short_name === this.bannedBackgroundCheck) {
          checkData['middle_name'] = this.middleName
      }
      if (check.short_name === this.amlBackgroundCheck) {
          checkData['birth_year'] = this.birth_year
          checkData['country_codes'] = this.selectedCodes.map(item => item.value);
          const option = this.fuzzinessOptions.find(opt => opt.value === this.fuzziness);
          checkData['fuzziness'] = option?.key || 'exact_match';
      }
      if (this.trust1337DirectorshipCreditChecks && check.short_name === ConstantsService.DIRECTORSHIP_CHECK_SHORT_NAME) {
          checkData['country'] = this.country
      }
      if (check.short_name === 'mobile_id'){
        for(const idCheck of check.flow){
          if (idCheck.checked===true){
            checkKey = idCheck.short_name
          }
        }
      }

      // Centric Credential/Education have no flow — attach fields on the parent check.
      if (this.trust1101Centric && check.short_name === ConstantsService.EDUV_SHORT_NAME && !check.flow?.length) {
          checkData['verification_type'] = this.verificationType
      }
      if (this.trust1101Centric && check.short_name === ConstantsService.CV_SHORT_NAME && !check.flow?.length) {
          checkData['verification_cred_min'] = this.verificationCredMin
          checkData['verification_cred_max'] = this.verificationCredMax
      }

      if(check.flow && check.short_name !== "mobile_id"){
          for (let flow of check.flow){
              if(flow.checked && flow.short_name === ConstantsService.EMPV_SQ_SHORT_NAME ){
                  checkData['verification_emp_min'] = this.verificationEmpMin
                  checkData['verification_emp_max'] = this.verificationEmpMax
              }
              if(flow.checked && flow.short_name === ConstantsService.EMPV_CP_SHORT_NAME ){
                  checkData['verification_years'] = this.employmentCoverage
              }
              if(flow.checked && flow.short_name === ConstantsService.EDUV_SQ_SHORT_NAME ){
                  if (this.trust1101Centric) {
                      checkData['verification_type'] = this.verificationType
                  } else {
                      checkData['verification_qual_min'] = this.verificationQualMin
                      checkData['verification_qual_max'] = this.verificationQualMax
                  }
              }
              if(this.trust1101Centric && flow.checked && flow.short_name === ConstantsService.EDUV_HL_SHORT_NAME ){
                  checkData['verification_type'] = this.verificationType
              }
              if(flow.checked && flow.short_name === ConstantsService.CV_SQ_SHORT_NAME ){
                  checkData['verification_cred_min'] = this.verificationCredMin
                  checkData['verification_cred_max'] = this.verificationCredMax
              }
          }
      }
      this.checks['checks'][checkKey] = checkData;
    }
    return this.checks

  }



  protected readonly ConstantsService = ConstantsService;

  disabledAddChecks() {
    if (this.isEdit){
      if (this.additionalFields) {
      for (let additionalField of this.additionalFields) {
        if (additionalField == 'role') {
          if (!this.role) {
            return true
          }
        }
        if (additionalField === 'hiring_organisation' || additionalField === 'place_work') {
          if (!this.hiringOrganisation) {
            return true
          }
          else if (additionalField === 'place_work' && (!this.hiringOrganisation || this.hiringOrganisation.length>100)){
            return true
          }
        }
        if (additionalField === 'employment_sector') {
          if (!this.employmentSector) {
            return true
          }
        }
        if (additionalField === 'country') {
          if (!this.country) {
            return true
          }
        }
        if (additionalField === 'type') {
          if (!this.employmentType) {
            return true
          }
        }
        if(additionalField === 'verification_emp_min') {
            if(Number(this.verificationEmpMin) > Number(this.verificationEmpMax)){
                return true
            }
        }
        if(additionalField === 'verification_qual_min') {
            if(Number(this.verificationQualMin) > Number(this.verificationQualMax)){
                return true
            }
        }
        if(additionalField === 'verification_cred_min') {
            if(Number(this.verificationCredMin) > Number(this.verificationCredMax)){
                return true
            }
        }
      }
    }
      return false;
    }
    if (this.selectedItems.length === 0) {
      return true;
    }
    if (this.additionalFields) {
      for (let additionalField of this.additionalFields) {
        if (additionalField == 'role') {
          if (!this.role) {
            return true
          }
        }
        if (additionalField === 'hiring_organisation' || additionalField === 'place_work') {
          if (!this.hiringOrganisation) {
            return true
          }
          else if (additionalField === 'place_work' && (!this.hiringOrganisation || this.hiringOrganisation.length>100)){
            return true
          }
        }
        if (additionalField === 'employment_sector') {
          if (!this.employmentSector) {
            return true
          }
        }
        if (additionalField === 'country') {
          if (!this.country) {
            return true
          }
        }
        if (additionalField === 'type') {
          if (!this.employmentType) {
            return true
          }
        }
        if (additionalField === 'role') {
          if (!this.role || this.role.length>100) {
            return true
          }
        }

        if(additionalField === 'verification_emp_min') {
            if(Number(this.verificationEmpMin) > Number(this.verificationEmpMax)){
                return true
            }
        }
        if(additionalField === 'verification_qual_min') {
            if(Number(this.verificationQualMin) > Number(this.verificationQualMax)){
                return true
            }
        }
        if(additionalField === 'verification_cred_min') {
            if(Number(this.verificationCredMin) > Number(this.verificationCredMax)){
                return true
            }
        }
      }
    }
    return false

  }

  reset() {
    this.role = '';
    this.hiringOrganisation = '';
    this.employmentSector = '';
    this.country = '';
    this.selectedItems = [];
    this.employmentType = '';
    this.employmentValue = '';
    this.items.forEach((item: any) => { item.checked = false; })
    this.selectedCodes = [];
    this.fuzziness = 'Exact match'
    this.middleName = '';
    this.birth_year = '';
  }

  containsMobileId(list){
    const hasMobileId = list.some(item => item.short_name === 'mobile_id');
    if(list.length > 3 && hasMobileId){
      return true
    }
    return false;
  }

  updateDropdownPosition(top: number, left: number): void {
    if (!this.styleElement.parentNode) {
      const specificSelector = 'body bs-dropdown-container';
      const styles = `
          ${specificSelector} {
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `;
      this.styleElement.textContent = styles;
      document.head.appendChild(this.styleElement);
    }
  }

  onSearchChange($event) {
    const filteredItems = $event.filteredItems;
    if(this.containsMobileId(filteredItems)){
      this.adjustDropdownStylesForMobileId();
    } else {
      this.removeFlowDropdownStyles();
    }
  }

  onSearchClear() {
    this.adjustDropdownStylesForMobileId();
  }

  dropDownOpened(items: boolean){
    this.multiSelectOpened = items;
    if(this.multiSelectHidden){
      this.multiSelectOpenedcount = 0;
    }
    else{
      this.multiSelectOpenedcount = this.multiSelectOpenedcount + 1;
    }
  }

  dropDownHidden(items: boolean){
    this.multiSelectHidden = items;
    this.multiSelectOpenedcount = 0;
  }

  protected readonly event = event;

  get isMiddleNameInvalid(): boolean {
    return !!(this.middleNameField?.invalid && this.middleNameField?.touched && this.middleNameField?.errors?.pattern);
  }

  updateYear(year) {
    this.birth_year = year.value;
  }

  updatefuzziness(fuziness) {
    this.fuzziness = fuziness.value;
  }

  selectedCodesEmitter($event) {
    this.selectedCodes = $event;
  }

  connectBCG(){
      // no need to check trust admin status or trust status. only allowed user to select BCG when trust admin status
      // is conected & trust is also connected
      let urlToOpen = this.trustUrl + this.languageLocal;
      window.open(urlToOpen);
  }

}
